module.exports = __webpack_public_path__ + "img/kit.30bf14c0.png";